import React from 'react';
import clsx from 'clsx';

import styles from './DetailItem.module.css';

interface DetailItemProps {
  title: string
  value: string
  className?: string
  titleClass?: string
  valueClass?: string
}


const DetailItem = (props: DetailItemProps) => {
  return (
    <div className={clsx(styles.row, props.className)}>
      <span className={clsx("flex", "alignCenter", props.titleClass)}>
        <span className="text is-title-small" data-manabie="detail-title">{props.title}</span>
      </span>
      <span className={clsx(styles.value, props.valueClass)} data-manabie="detail-value">{props.value}</span>
    </div>
  );
};

export default DetailItem;
